module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("95PDn"))).then(() => parcelRequire('iDabs'));